import { type InsuranceCorporateIdentity } from "../types";

export function BKKMTULogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M254.98 63.6882C273.484 63.5143 291.909 66.1335 309.631 71.4571C350.933 83.6685 387.078 109.114 412.503 143.878C437.768 179.893 450.649 223.141 449.205 267.11C449.205 267.11 428.22 198.35 336.421 168.882C301.249 158.758 264.325 156.232 228.102 161.47C203.645 164.352 180.37 173.588 160.592 188.26C160.413 147.897 175.326 64.9384 254.98 63.6882Z"
        fill="#95C11F"
      />
      <path
        d="M90.1354 355.605C80.7721 339.671 73.8492 322.423 69.5969 304.437C59.6068 262.661 63.5261 218.765 80.7592 179.419C99.2846 139.527 130.282 106.742 169.075 86.0131C169.075 86.0131 120.051 138.342 140.143 232.641C147.476 265.705 162.394 296.612 183.72 322.922C199.606 344.086 220.379 361.091 244.265 372.483C214.171 392.307 134.338 428.384 90.1354 355.605Z"
        fill="#FDC300"
      />
      <path
        d="M426.345 355.159C417.219 371.283 405.72 385.943 392.233 398.647C360.661 427.342 320.663 445.07 278.199 449.19C233.768 453.122 189.25 442.666 151.216 419.364C151.216 419.364 207.653 433.295 279.806 376.59C308.515 353.005 331.942 323.645 348.566 290.417C361.202 266.02 367.816 238.953 367.854 211.477C402.324 228.891 466.44 281.755 426.345 355.159Z"
        fill="#E8491B"
      />
      <path
        d="M305.88 263.806H260.338V309.438H253.284V263.806H207.652V256.663H253.284V211.031H260.338V256.663H305.88V263.806Z"
        fill="#706F6F"
      />
    </svg>
  );
}

export const BKKMTU: InsuranceCorporateIdentity = {
  id: "bkk-mtu",
  name: "BKK MTU",
  logo: BKKMTULogo,
  backgroundColor: "#FFFFFF",
  textColor: "#000000",
  wildcard: "bkk mtu",
  type: "statutory",
};
